/**
 * @flow
 * @relayHash c11b6fc7d7267e3109fd8d6240efc960
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type JobActivityTimelineList_job$ref = any;
export type JobActivityTimelineQueryVariables = {|
  id: string
|};
export type JobActivityTimelineQueryResponse = {|
  +job: ?{|
    +$fragmentRefs: JobActivityTimelineList_job$ref
  |}
|};
export type JobActivityTimelineQuery = {|
  variables: JobActivityTimelineQueryVariables,
  response: JobActivityTimelineQueryResponse,
|};
*/


/*
query JobActivityTimelineQuery(
  $id: ID!
) {
  job(uuid: $id) {
    __typename
    ...JobActivityTimelineList_job
    ... on Node {
      id
    }
  }
}

fragment JobActivityTimelineList_job on Job {
  ... on JobTypeCommand {
    uuid
    state
    createdAt
    ...JobEventCreated_job
    events(first: 30) {
      edges {
        node {
          __typename
          uuid
          timestamp
          type
          ...JobEventLimited_event
          ...JobEventFinished_event
          ...JobEventRetried_event
          ...JobEventScheduled_event
          ...JobEventAssigned_event
          ...JobEventCanceled_event
          ...JobEventCancelation_event
          ...JobEventAccepted_event
          ...JobEventStarted_event
          ...JobEventTimedOut_event
          ...JobEventChanged_event
          ...JobEventBuildStepUploadCreated_event
          id
        }
      }
    }
  }
}

fragment JobEventCreated_job on JobTypeCommand {
  uuid
  createdAt
  agentQueryRules
  cluster {
    name
    uuid
    organization {
      slug
      id
    }
    id
  }
  clusterQueue {
    key
    uuid
    cluster {
      name
      uuid
      organization {
        slug
        id
      }
      id
    }
    id
  }
  concurrency {
    group
    limit
  }
  step {
    uuid
    key
    conditional
    dependencies(first: 10) {
      edges {
        node {
          uuid
          key
          id
        }
      }
    }
  }
}

fragment JobEventLimited_event on JobEvent {
  timestamp
  job {
    concurrency {
      group
      limit
    }
    id
  }
}

fragment JobEventFinished_event on JobEvent {
  timestamp
  ... on JobEventFinished {
    exitStatus
  }
  actor {
    type
  }
  job {
    softFailed
    exitStatus
    agent {
      ...AgentBadge_agent
      heartbeatAt
      id
    }
    id
  }
}

fragment JobEventRetried_event on JobEvent {
  timestamp
  actor {
    type
    node {
      __typename
      ... on User {
        name
        uuid
        ...UserAvatar_user
      }
      ... on Node {
        id
      }
      ... on Dispatch {
        id
      }
    }
  }
  ... on JobEventRetried {
    automaticRule {
      exitStatus
      limit
    }
    retriedInJob {
      uuid
      id
    }
  }
}

fragment JobEventScheduled_event on JobEvent {
  timestamp
}

fragment JobEventAssigned_event on JobEvent {
  timestamp
}

fragment JobEventCanceled_event on JobEvent {
  timestamp
  ... on JobEventCanceled {
    exitStatus
  }
  actor {
    node {
      __typename
      ...AgentBadge_agent
      ... on Agent {
        name
        uuid
        organization {
          slug
          id
        }
      }
      ... on Node {
        id
      }
      ... on Dispatch {
        id
      }
    }
  }
}

fragment JobEventCancelation_event on JobEvent {
  timestamp
  actor {
    node {
      __typename
      ... on User {
        name
        ...UserAvatar_user
      }
      ... on Node {
        id
      }
      ... on Dispatch {
        id
      }
    }
  }
}

fragment JobEventAccepted_event on JobEvent {
  timestamp
  job {
    agent {
      ...AgentBadge_agent
      ...AgentUpgradeBanner_agent
      hostname
      version
      versionHasKnownIssues
      isDeprecated
      operatingSystem {
        name
      }
      id
    }
    id
  }
}

fragment JobEventStarted_event on JobEvent {
  timestamp
  job {
    agent {
      ...AgentBadge_agent
      id
    }
    id
  }
}

fragment JobEventTimedOut_event on JobEvent {
  timestamp
  ... on JobEventTimedOut {
    exitStatus
  }
  actor {
    node {
      __typename
      ...AgentBadge_agent
      ... on Agent {
        name
        uuid
        organization {
          slug
          id
        }
      }
      ... on Node {
        id
      }
      ... on Dispatch {
        id
      }
    }
  }
}

fragment JobEventChanged_event on JobEvent {
  timestamp
}

fragment JobEventBuildStepUploadCreated_event on JobEvent {
  timestamp
  actor {
    node {
      __typename
      ...AgentBadge_agent
      ... on Node {
        id
      }
      ... on Dispatch {
        id
      }
    }
  }
  ... on JobEventBuildStepUploadCreated {
    buildStepUpload {
      definition {
        yaml
      }
      id
    }
  }
}

fragment AgentBadge_agent on Agent {
  name
  uuid
  version
  versionHasKnownIssues
  organization {
    slug
    id
  }
}

fragment AgentUpgradeBanner_agent on Agent {
  version
}

fragment UserAvatar_user on User {
  name
  avatar {
    url
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "uuid",
    "variableName": "id",
    "type": "ID!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "uuid",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "organization",
  "storageKey": null,
  "args": null,
  "concreteType": "Organization",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "slug",
      "args": null,
      "storageKey": null
    },
    v3
  ]
},
v7 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "cluster",
  "storageKey": null,
  "args": null,
  "concreteType": "Cluster",
  "plural": false,
  "selections": [
    v5,
    v4,
    v6,
    v3
  ]
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "key",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "limit",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "concurrency",
  "storageKey": null,
  "args": null,
  "concreteType": "JobConcurrency",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "group",
      "args": null,
      "storageKey": null
    },
    v9
  ]
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "version",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "versionHasKnownIssues",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "exitStatus",
  "args": null,
  "storageKey": null
},
v15 = [
  v14
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "JobActivityTimelineQuery",
  "id": null,
  "text": "query JobActivityTimelineQuery(\n  $id: ID!\n) {\n  job(uuid: $id) {\n    __typename\n    ...JobActivityTimelineList_job\n    ... on Node {\n      id\n    }\n  }\n}\n\nfragment JobActivityTimelineList_job on Job {\n  ... on JobTypeCommand {\n    uuid\n    state\n    createdAt\n    ...JobEventCreated_job\n    events(first: 30) {\n      edges {\n        node {\n          __typename\n          uuid\n          timestamp\n          type\n          ...JobEventLimited_event\n          ...JobEventFinished_event\n          ...JobEventRetried_event\n          ...JobEventScheduled_event\n          ...JobEventAssigned_event\n          ...JobEventCanceled_event\n          ...JobEventCancelation_event\n          ...JobEventAccepted_event\n          ...JobEventStarted_event\n          ...JobEventTimedOut_event\n          ...JobEventChanged_event\n          ...JobEventBuildStepUploadCreated_event\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment JobEventCreated_job on JobTypeCommand {\n  uuid\n  createdAt\n  agentQueryRules\n  cluster {\n    name\n    uuid\n    organization {\n      slug\n      id\n    }\n    id\n  }\n  clusterQueue {\n    key\n    uuid\n    cluster {\n      name\n      uuid\n      organization {\n        slug\n        id\n      }\n      id\n    }\n    id\n  }\n  concurrency {\n    group\n    limit\n  }\n  step {\n    uuid\n    key\n    conditional\n    dependencies(first: 10) {\n      edges {\n        node {\n          uuid\n          key\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment JobEventLimited_event on JobEvent {\n  timestamp\n  job {\n    concurrency {\n      group\n      limit\n    }\n    id\n  }\n}\n\nfragment JobEventFinished_event on JobEvent {\n  timestamp\n  ... on JobEventFinished {\n    exitStatus\n  }\n  actor {\n    type\n  }\n  job {\n    softFailed\n    exitStatus\n    agent {\n      ...AgentBadge_agent\n      heartbeatAt\n      id\n    }\n    id\n  }\n}\n\nfragment JobEventRetried_event on JobEvent {\n  timestamp\n  actor {\n    type\n    node {\n      __typename\n      ... on User {\n        name\n        uuid\n        ...UserAvatar_user\n      }\n      ... on Node {\n        id\n      }\n      ... on Dispatch {\n        id\n      }\n    }\n  }\n  ... on JobEventRetried {\n    automaticRule {\n      exitStatus\n      limit\n    }\n    retriedInJob {\n      uuid\n      id\n    }\n  }\n}\n\nfragment JobEventScheduled_event on JobEvent {\n  timestamp\n}\n\nfragment JobEventAssigned_event on JobEvent {\n  timestamp\n}\n\nfragment JobEventCanceled_event on JobEvent {\n  timestamp\n  ... on JobEventCanceled {\n    exitStatus\n  }\n  actor {\n    node {\n      __typename\n      ...AgentBadge_agent\n      ... on Agent {\n        name\n        uuid\n        organization {\n          slug\n          id\n        }\n      }\n      ... on Node {\n        id\n      }\n      ... on Dispatch {\n        id\n      }\n    }\n  }\n}\n\nfragment JobEventCancelation_event on JobEvent {\n  timestamp\n  actor {\n    node {\n      __typename\n      ... on User {\n        name\n        ...UserAvatar_user\n      }\n      ... on Node {\n        id\n      }\n      ... on Dispatch {\n        id\n      }\n    }\n  }\n}\n\nfragment JobEventAccepted_event on JobEvent {\n  timestamp\n  job {\n    agent {\n      ...AgentBadge_agent\n      ...AgentUpgradeBanner_agent\n      hostname\n      version\n      versionHasKnownIssues\n      isDeprecated\n      operatingSystem {\n        name\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment JobEventStarted_event on JobEvent {\n  timestamp\n  job {\n    agent {\n      ...AgentBadge_agent\n      id\n    }\n    id\n  }\n}\n\nfragment JobEventTimedOut_event on JobEvent {\n  timestamp\n  ... on JobEventTimedOut {\n    exitStatus\n  }\n  actor {\n    node {\n      __typename\n      ...AgentBadge_agent\n      ... on Agent {\n        name\n        uuid\n        organization {\n          slug\n          id\n        }\n      }\n      ... on Node {\n        id\n      }\n      ... on Dispatch {\n        id\n      }\n    }\n  }\n}\n\nfragment JobEventChanged_event on JobEvent {\n  timestamp\n}\n\nfragment JobEventBuildStepUploadCreated_event on JobEvent {\n  timestamp\n  actor {\n    node {\n      __typename\n      ...AgentBadge_agent\n      ... on Node {\n        id\n      }\n      ... on Dispatch {\n        id\n      }\n    }\n  }\n  ... on JobEventBuildStepUploadCreated {\n    buildStepUpload {\n      definition {\n        yaml\n      }\n      id\n    }\n  }\n}\n\nfragment AgentBadge_agent on Agent {\n  name\n  uuid\n  version\n  versionHasKnownIssues\n  organization {\n    slug\n    id\n  }\n}\n\nfragment AgentUpgradeBanner_agent on Agent {\n  version\n}\n\nfragment UserAvatar_user on User {\n  name\n  avatar {\n    url\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "JobActivityTimelineQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "job",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "JobActivityTimelineList_job",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "JobActivityTimelineQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "job",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          v2,
          v3,
          {
            "kind": "InlineFragment",
            "type": "JobTypeCommand",
            "selections": [
              v4,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "state",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "agentQueryRules",
                "args": null,
                "storageKey": null
              },
              v7,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "clusterQueue",
                "storageKey": null,
                "args": null,
                "concreteType": "ClusterQueue",
                "plural": false,
                "selections": [
                  v8,
                  v4,
                  v7,
                  v3
                ]
              },
              v10,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "step",
                "storageKey": null,
                "args": null,
                "concreteType": "StepCommand",
                "plural": false,
                "selections": [
                  v4,
                  v8,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "conditional",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "dependencies",
                    "storageKey": "dependencies(first:10)",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 10,
                        "type": "Int"
                      }
                    ],
                    "concreteType": "DependencyConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DependencyEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Dependency",
                            "plural": false,
                            "selections": [
                              v4,
                              v8,
                              v3
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "events",
                "storageKey": "events(first:30)",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 30,
                    "type": "Int"
                  }
                ],
                "concreteType": "JobEventConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobEventEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": false,
                        "selections": [
                          v2,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "actor",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "JobEventActor",
                            "plural": false,
                            "selections": [
                              v11,
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": null,
                                "plural": false,
                                "selections": [
                                  v2,
                                  v3,
                                  {
                                    "kind": "InlineFragment",
                                    "type": "Agent",
                                    "selections": [
                                      v5,
                                      v4,
                                      v12,
                                      v13,
                                      v6
                                    ]
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "User",
                                    "selections": [
                                      v5,
                                      v4,
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "avatar",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "Avatar",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "url",
                                            "args": null,
                                            "storageKey": null
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          v4,
                          v11,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "job",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "JobTypeCommand",
                            "plural": false,
                            "selections": [
                              v10,
                              v3,
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "softFailed",
                                "args": null,
                                "storageKey": null
                              },
                              v14,
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "agent",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Agent",
                                "plural": false,
                                "selections": [
                                  v5,
                                  v4,
                                  v12,
                                  v13,
                                  v6,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "heartbeatAt",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  v3,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "hostname",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isDeprecated",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "operatingSystem",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "OperatingSystem",
                                    "plural": false,
                                    "selections": [
                                      v5
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "timestamp",
                            "args": null,
                            "storageKey": null
                          },
                          v3,
                          {
                            "kind": "InlineFragment",
                            "type": "JobEventBuildStepUploadCreated",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "buildStepUpload",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "BuildStepUpload",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "definition",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "BuildStepUploadDefinition",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "yaml",
                                        "args": null,
                                        "storageKey": null
                                      }
                                    ]
                                  },
                                  v3
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "JobEventTimedOut",
                            "selections": v15
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "JobEventCanceled",
                            "selections": v15
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "JobEventRetried",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "automaticRule",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "JobRetryRuleAutomatic",
                                "plural": false,
                                "selections": [
                                  v14,
                                  v9
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "retriedInJob",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "JobTypeCommand",
                                "plural": false,
                                "selections": [
                                  v4,
                                  v3
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "JobEventFinished",
                            "selections": v15
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ea212100e343498014b1f8cae4b45b14';
module.exports = node;
